import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { ArrowLeft } from "mdi-material-ui";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            marginTop: theme.spacing(2),
            color: theme.palette.action.active,
        },
    })
);

interface IBackButtonProps {
    onClicked: () => void;
    isSubmitting?: boolean;
}

export const BackButton = observer((props: IBackButtonProps) => {

    /********* React hooks *********/

    const classes = useStyles();

    /********* Event handlers *********/

    const handleBackClicked = () => {
        props.onClicked();
    }

    /********* Render *********/

    return (
        <Button
            onClick={handleBackClicked}
            disabled={props.isSubmitting}
            className={classes.backButton}
            startIcon={<ArrowLeft />}
        >
            Back
        </Button>
    );
});